import { PublicOpenListingPage } from "./applications/PublicOpenListingPage";

export function PublicShareItemPage() {
  return <PublicOpenListingPage />;
}
